import styles from './DonationFormSkeletonLoader.module.scss'

export function DonationFormSkeletonLoader() {
  const hideFooter = window.location.search.indexOf('showFooter=false') > 0

  return (
    <div className={styles.formWrapper} data-testid="donation-form-skeleton-loader">
      <div className={styles.loaderContentWrapper}>
        <div className={styles.logoBox}>
          <div className={styles.logo} />
          <div className={styles.titleBox}>
            <div className={styles.logoTitleLine1} />
            <div className={styles.logoTitleLine2} />
          </div>
        </div>

        <div className={styles.contentFlex}>
          <div className={styles.largeSkeleton} />

          <div className={styles.presetSkeleton}>
            <span />
            <span />
            <span />
            <span />
          </div>

          <div className={styles.flexColumn}>
            <div className={styles.inputSkeleton} />
          </div>

          <div className={styles.flexRow}>
            <div className={styles.circleSkeleton} />
            <div className={styles.rowBarSkeleton} />
          </div>
        </div>

        <div className={styles.bottomSkeleton} />
      </div>

      {!hideFooter && <div className={styles.footerSkeleton} data-testid="skeleton-footer" />}
    </div>
  )
}
